import React from "react";
import { Scrollbar } from "react-scrollbars-custom";
import styles from "./scrollbar.module.scss";
import {isRTL} from "../../../utils/rtl";

interface CustomScrollbarProps {
  children: React.ReactNode;
  height?: number | string;
  width?: number | string;
  marginTop?: number | string;
  marginBottom?: number | string;
  marginRight?: number | string;
  marginLeft?: number | string;
  minHeight?: number | string;
  enabled?: boolean;
  flex?: number | string;
}

const CustomScrollbar: React.FC<CustomScrollbarProps> = ({
  children,
  height = "100%",
  width = "100%",
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  minHeight,
  enabled = true,
  flex
}) => {

  if (!enabled) {
    return <>{children}</>;
  }

  const scrollbarStyle: React.CSSProperties = {
    width,
    minHeight: minHeight || undefined,
    flex: flex || undefined,
  };

  if (!minHeight && height && !flex) {
    scrollbarStyle.height = height;
  }
  const rtl = isRTL();

  const trackStyle: React.CSSProperties = {
    backgroundColor: "transparent",
    width: "8px",
    marginTop,
    marginBottom,
    ...(rtl
        ? {
          marginLeft: marginRight,
          marginRight: marginLeft,
        }
        : {
          marginLeft,
          marginRight,
        }),
  };

  return (
    <Scrollbar
      rtl={rtl}
      className="scrollbar"
      noScrollX={true}
      style={scrollbarStyle}
      thumbYProps={{ className: `${styles.customThumb}` }}
      trackYProps={{
        style: trackStyle,
      }}
    >
      {children}
    </Scrollbar>
  );
};

export default CustomScrollbar;
